import React, { Dispatch, SetStateAction } from 'react'
import { Button, Icon, IconType, GradientPageHeader } from '@lmc/ui-kit'
import styled from 'styled-components'
import Search from '@lmc/ui-kit/src/dataEntry/Input/components/Search/Search'
import { useRoleAccess } from 'components/AccessControl'
import { UserRole } from '@lmc/ts-common'

type ResidentListHeaderProps = {
  openModal: () => void
  onSearch: Dispatch<SetStateAction<string>>
  title?: string
  searchPlaceholder?: string
  buttonTitle?: string
}

const StyledContainer = styled.div`
  max-width: 100%;
  margin-top: 24px;
  margin-bottom: 0px;
  margin-left: 24px;
  margin-right: 24px;
`

const StyledChild = styled.div`
  display: flex;
  ${({ theme }) => theme.mediaQueries.mobileDown} {
    flex-direction: column;
    margin-right: auto;
  }
`

const StyledSearch = styled(Search)`
  margin-right: 10px;
  width: 200px;
  ${({ theme }) => theme.mediaQueries.mobileDown} {
    margin-bottom: 10px;
  }
`

const StyledMail = styled(Icon)`
  color: white;
`

const ResidentListHeader: React.FC<ResidentListHeaderProps> = ({
  openModal,
  onSearch,
  title,
  searchPlaceholder,
  buttonTitle,
}) => {
  const hasRolePermission = useRoleAccess(
    [UserRole.careHomeAdmin],
    [
      {
        i: 'create',
        this: 'Resident',
      },
    ]
  )

  return (
    <StyledContainer>
      <GradientPageHeader title={title as string} gradient>
        <StyledChild>
          <StyledSearch
            placeholder={searchPlaceholder}
            onChange={(value) => onSearch(value?.target?.value)}
          />
          <Button
            onClick={openModal}
            variant="primary"
            icon={<StyledMail customIcon={IconType.Mail} />}
            disabledByPermission={!hasRolePermission}
          >
            {buttonTitle}
          </Button>
        </StyledChild>
      </GradientPageHeader>
    </StyledContainer>
  )
}

export default ResidentListHeader
